export default function FloatingToolbar({ children }: { children: React.ReactNode }) {
  return (
    <div
      className="absolute left-1/2 top-0 z-20 flex -translate-x-1/2 -translate-y-1/2 items-stretch divide-x divide-white/25 rounded-full bg-violet-600 text-white shadow-lg print:hidden [&>:first-child]:rounded-l-full [&>:first-child>button]:rounded-l-full [&>:last-child]:rounded-r-full [&>:last-child>button]:rounded-r-full"
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </div>
  );
}

export function ToolbarButton({
  label,
  onClick,
  disabled,
  children,
}: {
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  children: React.ReactNode;
}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      title={label}
      className="flex items-center gap-1 px-3 py-2 text-sm font-medium transition hover:bg-white/15 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-transparent"
    >
      {children}
    </button>
  );
}
